<script setup lang="ts">
import { BoxContainerData } from '@/page/domain/CarrierPageData';
import BoxContent from '@/page/infrastructure/components/carrier/BoxContent.vue';

defineProps<{
  content: Partial<BoxContainerData>
}>();
</script>
<template>
  <div class="flex flex-col text-center w-full px-2">
    <BoxContent v-if="content.boxData" :content="content.boxData"></BoxContent>
    <h3 class="mb-2" v-html="content.title"></h3>
    <div class="mb-6" v-html="content.content"></div>
  </div>
</template>
